const MAX_VISIBLE_ITEMS = 5;

const getAccordionBlocks = () => document.querySelectorAll('.mobile-accordion-block');
const isMobileView = () => window.innerWidth <= 768;

function createAccordionItem(card) {
  const titleEl = card.querySelector('.content-card-title');
  if (!titleEl) return null;

  const accordionItem = document.createElement('div');
  accordionItem.classList.add('accordion-item');

  const accordionHeader = document.createElement('button');
  accordionHeader.classList.add('accordion-header');
  accordionHeader.innerHTML = titleEl.innerHTML;

  const accordionBody = document.createElement('div');
  accordionBody.classList.add('accordion-body');

  Array.from(card.children).forEach(child => {
    if (!child.classList.contains('content-card-title')) {
      accordionBody.appendChild(child.cloneNode(true));
    }
  });

  accordionItem.appendChild(accordionHeader);
  accordionItem.appendChild(accordionBody);

  return accordionItem;
}

function insertLoadMoreButton(block, accordionItems) {
  const remainingCount = accordionItems.length - MAX_VISIBLE_ITEMS;
  const loadMoreBtn = document.createElement('button');
  loadMoreBtn.classList.add('load-more-btn');
  loadMoreBtn.textContent = `Load More Features (${remainingCount})`;

  const notAccordionRow = block.querySelector('.content-cards-row-not-accordion');
  if (notAccordionRow) {
    notAccordionRow.parentNode.insertBefore(loadMoreBtn, notAccordionRow);
  } else {
    block.appendChild(loadMoreBtn);
  }

  loadMoreBtn.addEventListener('click', () => {
    accordionItems.forEach(item => item.classList.remove('hidden-item'));
    loadMoreBtn.remove();
  });
}

function setupAccordionItems(block) {
  const rows = block.querySelectorAll(
    '.content-cards-row:not(.content-cards-row-not-accordion)'
  );

  rows.forEach(row => {
    const cards = row.querySelectorAll('.content-card');
    cards.forEach(card => {
      const accordionItem = createAccordionItem(card);
      if (accordionItem) {
        row.parentNode.insertBefore(accordionItem, row);
      }
    });
    row.remove();
  });

  const accordionItems = block.querySelectorAll('.accordion-item');
  if (accordionItems.length > MAX_VISIBLE_ITEMS) {
    accordionItems.forEach((item, index) => {
      if (index >= MAX_VISIBLE_ITEMS) item.classList.add('hidden-item');
    });
    insertLoadMoreButton(block, accordionItems);
  }
}

function toggleAccordion(e) {
  if (!e.target.classList.contains('accordion-header')) return;

  const header = e.target;
  const body = header.nextElementSibling;

  if (header.classList.contains('active')) {
    header.classList.remove('active');
    body.classList.remove('open');
    return;
  }

  const allHeaders = document.querySelectorAll('.accordion-header');
  const allBodies = document.querySelectorAll('.accordion-body');

  allHeaders.forEach(h => h.classList.remove('active'));
  allBodies.forEach(b => b.classList.remove('open'));

  header.classList.add('active');
  body.classList.add('open');
}

function initAccordion() {
  if (!isMobileView()) return;

  const accordionBlocks = getAccordionBlocks();
  if (!accordionBlocks.length) return;

  accordionBlocks.forEach(block => setupAccordionItems(block));
  document.addEventListener('click', toggleAccordion);
}

document.addEventListener('DOMContentLoaded', initAccordion);
